module.exports = __webpack_public_path__ + "img/exante_cura_nucleo.84b5ff9a.jpg";